import { MapPin, Mail, Phone, Facebook, Instagram, MessageCircle } from "lucide-react";

/**
 * Slim red utility bar at the very top of the site with business contact
 * details. Follows the reference mockup exactly. Hidden on very small screens
 * to keep the header compact.
 */
const TopContactBar = () => (
  <div className="vd-topbar hidden md:block" data-testid="top-contact-bar" style={{ background: "var(--primary-red)", color: "#fff" }}>
    <div className="vd-container flex items-center justify-between text-[13px] py-2">
      <div className="flex items-center gap-6">
        <span className="inline-flex items-center gap-1.5" data-testid="topbar-location">
          <MapPin size={14} /> Middlesbrough, United Kingdom
        </span>
        <a href="mailto:info@valuedriveauto.co.uk" className="inline-flex items-center gap-1.5 hover:underline" data-testid="topbar-email">
          <Mail size={14} /> info@valuedriveauto.co.uk
        </a>
      </div>
      <div className="flex items-center gap-4">
        <a href="tel:07979210250" className="inline-flex items-center gap-1.5 font-semibold hover:underline" data-testid="topbar-phone">
          <Phone size={14} /> 07979 210250
        </a>
        <span className="opacity-40">·</span>
        <a href="#" aria-label="Facebook" className="inline-flex hover:opacity-80" data-testid="topbar-facebook"><Facebook size={15} /></a>
        <a href="#" aria-label="Instagram" className="inline-flex hover:opacity-80" data-testid="topbar-instagram"><Instagram size={15} /></a>
        <a href="https://wa.me/447979210250" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" className="inline-flex hover:opacity-80" data-testid="topbar-whatsapp"><MessageCircle size={15} /></a>
      </div>
    </div>
  </div>
);

export default TopContactBar;
